module.exports = __webpack_public_path__ + "static/img/times.de18432f.png";